import * as TK from 'components/common/BackButton/translations/constants';
import { Translations } from 'translations/types';

export const backButtonEnUsLocale: Translations = {
  [TK.BACK_BUTTON_DEFAULT_LABEL]: 'Back',
};
